import axios from "axios";
import { tmsApi } from "../api";

export const getOtpList = (obj) => {
    const config = {
        headers: {
            token: localStorage.getItem("token"),
            "Access-Control-Allow-Origin": "*"
        },
    };
    try {
        return axios
            .post(tmsApi + `v1/entities/otp/find?page=${obj.page}&size=${obj.size}`,
                {
                    searchTerm: ""
                }, config)
            .then((resp) => {
                console.log(resp, "response");
                return resp;
            });
    } catch (error) {
        console.log("error", error);
    }
};

export const getOtpListBySearch = (obj) => {
    const config = {
        headers: {
            token: localStorage.getItem("token"),
            "Access-Control-Allow-Origin": "*"
        },
    };
    try {
        return axios
            .post(tmsApi + `v1/entities/otp/find?page=${obj.page}&size=${obj.size}`,
                {
                    searchTerm: obj.searchTerm
                }, config)
            .then((resp) => {
                console.log(resp, "response");
                return resp;
            });
    } catch (error) {
        console.log("error", error);
    }
};